import { toast } from "sonner";

const scriptOf = (html) => (html.match(/\/static\/js\/main\.[^"']+\.js/) || [])[0];
const current = () =>
  [...document.scripts].map((s) => s.getAttribute("src") || "").find((s) => /\/static\/js\/main\./.test(s));

let shown = false;

async function check() {
  if (shown || document.visibilityState !== "visible") return;
  try {
    const res = await fetch(`/?v=${Date.now()}`, { cache: "no-store" });
    const latest = scriptOf(await res.text());
    const mine = current();
    if (!latest || !mine || mine.endsWith(latest) || latest.endsWith(mine)) return;
    shown = true;
    toast("È disponibile una nuova versione di Coach2Go", {
      id: "app-update",
      duration: Infinity,
      action: { label: "Aggiorna", onClick: () => window.location.reload() },
    });
  } catch (_) {}
}

export function startUpdateCheck() {
  setTimeout(check, 5000);
  setInterval(check, 5 * 60 * 1000);
  document.addEventListener("visibilitychange", check);
}
